import type { PropsWithChildren, ReactElement } from 'react';

import { createContext, useContext } from 'react';

import type { ProductStockLocator } from '~/amplienceTypes/schemas/imported/product-stock-locator-schema';

type StockLocatorContentType = ProductStockLocator | undefined;

const StockLocatorContentContext = createContext<StockLocatorContentType>(undefined);

export const useStockLocatorContext = (): ProductStockLocator => {
  const context = useContext(StockLocatorContentContext);

  if (context === undefined) {
    throw new Error('useStockLocatorContext must be used within a StockLocatorContentProvider');
  }

  return context;
};

export const StockLocatorContentProvider = ({
  children,
  content,
}: PropsWithChildren<{ content: StockLocatorContentType }>): ReactElement => (
  <StockLocatorContentContext value={content}>{children}</StockLocatorContentContext>
);
